import { SupportedLanguage } from "./types";
export const DEFAULT_LANGUAGE = SupportedLanguage.EN;
export const LANGUAGE_PREFERENCE_KEY = "user_language_preference";
export const LOCALIZATION_CACHE_KEY_PREFIX = "localization_";
export const LANGUAGES = {
    en: {
        code: SupportedLanguage.EN,
        name: "English",
        symbol: "EN",
        direction: "ltr",
    },
    fr: {
        code: SupportedLanguage.FR,
        name: "Français",
        symbol: "FR",
        direction: "ltr",
    },
    ar: {
        code: SupportedLanguage.AR,
        name: "العربية",
        symbol: "AR",
        direction: "rtl",
    },
    de: {
        code: SupportedLanguage.DE,
        name: "Deutsch",
        symbol: "DE",
        direction: "ltr",
    },
    es: {
        code: SupportedLanguage.ES,
        name: "Español",
        symbol: "ES",
        direction: "ltr",
    },
    hi: {
        code: SupportedLanguage.HI,
        name: "हिन्दी",
        symbol: "HI",
        direction: "ltr",
    },
    ko: {
        code: SupportedLanguage.KO,
        name: "한국어",
        symbol: "KO",
        direction: "ltr",
    },
    pt: {
        code: SupportedLanguage.PT,
        name: "Português",
        symbol: "PT",
        direction: "ltr",
    },
    ru: {
        code: SupportedLanguage.RU,
        name: "Русский",
        symbol: "RU",
        direction: "ltr",
    },
};
